function printTemplate(title, list, LODOP) {
    // console.log(title, list)
    // 表格绘制
    let lineWidth = 1;
    let tableWidth = 735 // 表格宽度
    let tableLeft = 25; // 表格左外边距
    let fontSize = 11
    let contentFontSize = 10
    let marginTop = 15;

    // LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A5')
    // LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1) // 打印旋转

    LODOP.SET_PRINT_PAGESIZE(1, '210mm', '140mm');

    LODOP.ADD_PRINT_TEXT(marginTop + 5, tableLeft, 700, 30, isEmptyStr(title.recordId));
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 1);
    setFontSizeAndColor(8, "#000000", LODOP)

    LODOP.ADD_PRINT_HTM(marginTop, tableLeft + 670, 700, 30, `<div style="border: 1px solid #000; width: 40px; height: 20px; text-align: center; line-height: 18px; font-size: 10px;">普通</div>`);

    LODOP.ADD_PRINT_TEXT(marginTop + 5, tableLeft + 640, 100, 30, "#/&");
    LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
    setFontSizeAndColor(8, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 15, 0, 770, 30, isEmptyStr(title.company));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(18, "#000000", LODOP)
    // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 15);//字间距

    LODOP.ADD_PRINT_TEXT(marginTop + 45, 0, 770, 30, isEmptyStr(list.printTypeTitle));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(14, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft, 700, 30, `姓名：${isEmptyStr(title.patientName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft + 240, 700, 30, `性别：${isEmptyStr(title.sex)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft + 480, 700, 30, `年龄：${isEmptyStr(getAge(title.clinicalAge, title.year, title.month, title.day))}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 108, tableLeft, marginTop + 108, tableLeft + tableWidth + 1, 0, lineWidth);// 第一条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft, 700, 30, `手机号：${isEmptyStr(title.phoneNo)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft + 240, 700, 30, `科室：${isEmptyStr(title.laboratoryName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft + 480, 700, 30, `就诊日期：${isEmptyStr(title.clinicalTime)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 138, tableLeft, marginTop + 138, tableLeft + tableWidth + 1, 0, lineWidth);// 第二条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 150, tableLeft, 700, 30, "RP");
    setFontSizeAndColor(fontSize, "#000000", LODOP)
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 1);

    let htmlStr = '<div class="group" style="font-size:14px;">'

    for (let i = 0; i < list.length; i++) {
        let ele = list[i]
        if (ele.printType == 'group') {
            htmlStr += `<div style="margin-bottom: 8px;">${ele.printIndex}：</div>`
        } else if (ele.printType == 'useFn') {
            htmlStr += `
               <div style="display: flex;">
                  <span>用法：${ele.dosage != '' && ele.dosage != 0 ? isEmptyStr(ele.dosage + ele.dosageUnit) + '/次' : ''}</span>
                  <span style="margin-left: 10px;">${isEmptyStr(ele.usage)}</span>
                  <span style="margin-left: 10px;">${isEmptyStr(ele.frequency)}</span>
               </div>
            `
        } else if (ele.printType == 'nullRow') {
            htmlStr += `
               <div style="display: flex; height: 20px;"> </div>
            `
        } else {
            htmlStr += `
                <div style="display: flex; margin-bottom: 8px;">
                  <!-- text-overflow:ellipsis;-->
                  <span style="width: 40%; display: inline-block; white-space: nowrap; overflow: hidden;">${isEmptyStr(ele.drugName)}</span>
                  <span style="width: 30%;">${isEmptyStr(ele.specification)}</span>
                  <span style="width: 10%;">${isEmptyStr(ele.totalDosage)} ${isEmptyStr(ele.totalDosageUnit)}</span>
                  <span style="width: 20%;text-align: right;">${isEmptyStr(ele.dosage)}${isEmptyStr(ele.dosageUnit)}/次</span>
                </div>
            `
        }
    }

    htmlStr += '</div>'

    LODOP.ADD_PRINT_HTM(marginTop + 170, tableLeft, tableWidth, 450, htmlStr)

    LODOP.ADD_PRINT_TEXT(marginTop + 400, tableLeft, 700, 30, `医生: ${title.printDoctorName == 1 ? isEmptyStr(title.realName) : ''}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    // printTotalPrice == 1
    LODOP.ADD_PRINT_TEXT(marginTop + 400, tableLeft + 600, 700, 30, `金额：￥${isEmptyStr(list[0].amount)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 420, tableLeft, marginTop + 420, tableLeft + tableWidth + 1, 0, lineWidth);// 第四条横线

    LODOP.ADD_PRINT_TEXT(marginTop + 432, tableLeft, 700, 30, "审查：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 432, tableLeft + 200, 700, 30, "调配：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 432, tableLeft + 400, 700, 30, "核对：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 432, tableLeft + 600, 700, 30, "发药：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)
}

function printTemplateA5(title, list, LODOP) {
    // console.log(title, list)
    // 表格绘制
    let lineWidth = 1;
    let tableWidth = 500 // 表格宽度
    let tableLeft = 15; // 表格左外边距
    let fontSize = 11
    let contentFontSize = 10
    let marginTop = 35;

    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A5')
    // LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', '处方');

    LODOP.ADD_PRINT_TEXT(marginTop - 15, tableLeft, 540, 30, isEmptyStr(title.recordId) ? `NO.${title.recordId}` : '');
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 1);
    setFontSizeAndColor(8, "#000000", LODOP)

    LODOP.ADD_PRINT_HTM(marginTop - 20, tableLeft + 435, 540, 30, `<div style="border: 1px solid #000; width: 40px; height: 20px; text-align: center; line-height: 18px; font-size: 10px;">普通</div>`);

    LODOP.ADD_PRINT_TEXT(marginTop - 15, tableLeft + 400, 100, 30, "#/&");
    LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
    setFontSizeAndColor(8, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 15, 0, 540, 30, isEmptyStr(title.company));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(18, "#000000", LODOP)
    // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 15);//字间距

    LODOP.ADD_PRINT_TEXT(marginTop + 45, 0, 540, 30, isEmptyStr(list[0].printTypeTitle));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(14, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft, 540, 30, `姓名：${isEmptyStr(title.patientName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft + 180, 540, 30, `性别：${isEmptyStr(title.sex)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft + 340, 540, 30, `年龄：${isEmptyStr(getAge(title.clinicalAge, title.year, title.month, title.day))}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 108, tableLeft, marginTop + 108, tableLeft + tableWidth + 1, 0, lineWidth);// 第一条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft, 700, 30, `手机号：${isEmptyStr(title.phoneNo)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft + 180, 540, 30, `科室：${isEmptyStr(title.laboratoryName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft + 340, 540, 30, `就诊日期：${isEmptyStr(title.clinicalTime)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 138, tableLeft, marginTop + 138, tableLeft + tableWidth + 1, 0, lineWidth);// 第二条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 150, tableLeft, 700, 30, `临床诊断：${isEmptyStr(title.diagnosisResultString)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 168, tableLeft, marginTop + 168, tableLeft + tableWidth + 1, 0, lineWidth);// 第三条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 180, tableLeft, 700, 30, `过敏史：${isEmptyStr(title.allergyHistory)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 198, tableLeft, marginTop + 198, tableLeft + tableWidth + 1, 0, lineWidth);// 第四条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 210, tableLeft, 700, 30, "R");
    setFontSizeAndColor(fontSize + 5, "#000000", LODOP)
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

    LODOP.ADD_PRINT_TEXT(marginTop + 216, tableLeft + 14, 700, 30, "P");
    setFontSizeAndColor(fontSize, "#000000", LODOP)
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

    let htmlStr = '<div class="group" style="font-size:14px;">'

    for (let i = 0; i < list.length; i++) {
        let ele = list[i]
        if (ele.printType == 'group') {
            htmlStr += `<div style="margin-bottom: 8px;">${ele.printIndex}：</div>`
        } else if (ele.printType == 'useFn') {
            htmlStr += `
               <div style="display: flex;">
                  <span>用法：${ele.dosage != '' && ele.dosage != 0 ? isEmptyStr(ele.dosage + ele.dosageUnit) + '/次' : ''}</span>
                  <span style="margin-left: 10px;">${isEmptyStr(ele.usage)}</span>
                  <span style="margin-left: 10px;">${isEmptyStr(ele.frequency)}</span>
               </div>
            `
        } else if (ele.printType == 'nullRow') {
            htmlStr += `
               <div style="display: flex; height: 20px;"> </div>
            `
        } else {
            htmlStr += `
                <div style="display: flex; margin-bottom: 8px;">
                  <!-- text-overflow:ellipsis;-->
                  <span style="width: 40%; display: inline-block; white-space: nowrap; overflow: hidden;">${isEmptyStr(ele.drugName)}</span>
                  <span style="width: 30%;">${isEmptyStr(ele.specification)}</span>
                  <span style="width: 10%;">${isEmptyStr(ele.totalDosage)} ${isEmptyStr(ele.totalDosageUnit)}</span>
                  <span style="width: 20%;text-align: right;">${isEmptyStr(ele.dosage)}${isEmptyStr(ele.dosageUnit)}/次</span>
                </div>
            `
        }
    }

    htmlStr += '</div>'

    LODOP.ADD_PRINT_HTM(marginTop + 240, tableLeft, tableWidth, 450, htmlStr)

    // ${title.printDoctorName == 1 ? isEmptyStr(title.realName) : ''}
    LODOP.ADD_PRINT_TEXT(marginTop + 620, tableLeft, 700, 30, `医生: ${title.printDoctorName == 1 ? isEmptyStr(title.realName) : ''}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    if (title.printTotalPrice == 1) {
        LODOP.ADD_PRINT_TEXT(marginTop + 620, tableLeft + 400, tableWidth, 30, `金额：￥${isEmptyStr(list[0].amount)}`);
        setFontSizeAndColor(fontSize, "#000000", LODOP)
    }

    LODOP.ADD_PRINT_LINE(marginTop + 638, tableLeft, marginTop + 638, tableLeft + tableWidth + 1, 0, lineWidth);// 第五条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 650, tableLeft, 700, 30, "审查：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 650, tableLeft + 120, 700, 30, "调配：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 650, tableLeft + 240, 700, 30, "核对：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 650, tableLeft + 360, 700, 30, "发药：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 668, tableLeft, marginTop + 668, tableLeft + tableWidth + 1, 0, lineWidth);// 第六条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 680, tableLeft, 700, 30, `注：${isEmptyStr(title.remark)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 680, tableLeft + 360, 700, 30, `签名：`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)
}

const isEmptyStr = (value) => {
    if (value == null || value == undefined || value == '') {
        return ''
    }
    return value
}

const setFontSizeAndColor = (fontSize, color, LODOP) => {
    LODOP.SET_PRINT_STYLEA(0, "FontSize", fontSize);
    LODOP.SET_PRINT_STYLEA(0, "FontColor", color);
}

const getAge = (clinicalAge, year, month, day) => {
    if (clinicalAge) {
        return clinicalAge
    } else {
        let str = ''
        if (year > 0) {
            str += `${year}岁`
        }
        if (month > 0 && year >= 0 && year < 5) {
            str += `${month}月`
        }
        if (year === 0 && day > 0) {
            str += `${day}天`
        }
        return str
    }
}

export { printTemplateA5, printTemplate }